module.exports = __webpack_public_path__ + "assets/img/1-1.7c5c29e3.jpg";